import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";
import RequisitionReducer from "../reducers/RequisitionReducer";
import CvReducer from "../reducers/CvReducer";
import JobReducer from "../reducers/JobReducer";
import CreateJobReducer from "../reducers/CreateJobReducer"

const reducers = {
  form: formReducer,
  requisition: RequisitionReducer,
  cvs: CvReducer,
  jobs: JobReducer,
  newjob: CreateJobReducer
};

export default combineReducers(reducers);
